module.exports = __webpack_public_path__ + "static/media/weather-5.3568b399.svg";